import React from 'react'
import {
  Row,
  Col,
  Button
} from 'antd'
import { ExceptionOutlined } from '@ant-design/icons'
import logo from "../assets/images/logo.png"

const Page4034 = () => {

  return (
    <Row justify="center" align="middle" className="auth-container">
      <Col span={24}>
        <Row justify="center">
          <Col span={24} className="logo-container">
            <img src={logo} alt="" className="auth-logo" />
          </Col>
          <Col span={24}>
            <Row justify="center">
              <Col span={24} lg={{ span: 7 }}>
                <div className="form-container">
                  <div className="form-header">
                    <ExceptionOutlined style={{ fontSize: "10em" }} />
                    <h1>404 Page Not Found</h1>
                    <p>The page you are looking does not found.</p>
                    <span className=" ant-btn-lg">
                      <Button type="primary" onClick={() => window.location.herf = "/"} size="large">Go To Dashboard</Button>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Page4034
